import { RefreshCw, X } from 'lucide-react';
import { useState } from 'react';
import { useVersionCheck } from '@/hooks/useVersionCheck';

/**
 * Fixed banner shown at the top of the viewport when a new app version
 * is detected via /version.json polling. Users can refresh or dismiss.
 */
export function VersionBanner() {
  const { updateAvailable, refresh } = useVersionCheck();
  const [dismissed, setDismissed] = useState(false);

  if (!updateAvailable || dismissed) return null;

  return (
    <div className="bg-primary text-primary-foreground px-4 py-2 flex items-center justify-center gap-3 text-sm shrink-0">
      <RefreshCw className="h-4 w-4 flex-shrink-0 animate-spin" />
      <span>A new version of the app is available.</span>
      <button
        onClick={refresh}
        className="underline font-medium hover:opacity-80 min-h-[44px] min-w-[44px] flex items-center"
      >
        Refresh now
      </button>
      <button
        onClick={() => setDismissed(true)}
        className="ml-2 p-1 hover:opacity-80 min-h-[44px] min-w-[44px] flex items-center justify-center"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
